import { Box } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { ReceivableDetails } from '~/packages/loanProduct/ui/receivablesDashboard/details/ReceivableDetails';

// Types
const RouteParamsStruct = z.object({
  finleyReceivableId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const params = useParams();
  const { finleyReceivableId } = RouteParamsStruct.parse(params);

  return (
    <ReceivableDetails
      organizationId={user.organization.id}
      finleyReceivableId={finleyReceivableId}
      isLenderPage
    />
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <Box width="100%" padding="2.5rem">
        <RouteBase />
      </Box>
    </RouteErrorBoundary>
  );
};
